<template>
  <v-data-table
    :headers="headers"
    :items="userApprovals"
    :search="search"
    class="elevation-1"
    v-model="selected"
    item-key="username"
    multi-sort
    :loading="loading"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-text-field
          flat
          solo
          prepend-icon="search"
          placeholder="Search"
          v-model="search"
          hide-details
          class="hidden-sm-and-down"
        ></v-text-field>

        <v-spacer></v-spacer>

        <v-bottom-sheet v-model="sheet">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              class="d-none mb-2"
              v-bind="attrs"
              v-on="on"
              @click="clearSheet"
            >
              New User Exam
            </v-btn>
          </template>

          <v-card>
            <v-tabs
              centered
              fixed-tabs
              background-color="cyan"
              dark
              icons-and-text
              v-model="tab"
            >
              <v-spacer></v-spacer>

              <v-tabs-slider color="yellow"></v-tabs-slider>
              <v-tab href="#tab-1">
                User Info
                <v-icon>mdi-badge-account-horizontal-outline</v-icon>
              </v-tab>

              <!-- <v-tab href="#tab-2">
                Exam Info
                <v-icon>mdi-school-outline</v-icon>
              </v-tab> -->

              <v-spacer></v-spacer>

              <!-- <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editMode = !editMode"
                v-if="!editMode && checkRole(['lf', 'ROLE_DEALERADMIN'])"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn> -->

              <!-- <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="editMode = !editMode"
                v-if="editMode"
              >
                <v-icon>mdi-pencil-off</v-icon>
              </v-btn> -->

              <v-btn
                class="align-self-center mr-4"
                icon
                dark
                fab
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>

              <v-tab-item :key="1" :value="'tab-1'">
                <v-card flat>
                  <v-form ref="form">
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.fullName"
                            label="Full Name"
                            name="fullName"
                            color="cyan"
                            readonly
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.username"
                            name="username"
                            label="Username"
                            color="cyan"
                            readonly
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.email"
                            label="E-mail"
                            name="email"
                            color="cyan"
                            readonly
                          ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.phone"
                            label="Phone"
                            color="cyan"
                            readonly
                          ></v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            v-model="editedItem.companyName"
                            label="Company Name"
                            color="cyan"
                            hint="This is the company name the user provided. Select the corresponding company in the following field."
                            persistent-hint
                            readonly
                          >
                            <!-- <template v-slot:append>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="companyCopy()"
                                  >
                                    mdi-content-copy
                                  </v-icon>
                                </template>
                                <span>Copy to Company field</span>
                              </v-tooltip>
                            </template> -->
                          </v-text-field>
                        </v-col>

                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-autocomplete
                            v-model="editedItem.customerID"
                            label="Company"
                            name="company"
                            :items="customers"
                            item-text="customerName"
                            item-value="customerID"
                            color="cyan"
                            item-color="cyan"
                          ></v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col
                          cols="12"
                          sm="6"
                        >
                          <v-text-field
                            v-model="editedItem.role"
                            label="Role"
                            color="cyan"
                            readonly
                          >
                            <template v-slot:append>
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="roleSwap()"
                                  >
                                    mdi-swap-horizontal
                                  </v-icon>
                                </template>
                                <span>Swap roles</span>
                              </v-tooltip>
                            </template>
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-container>
                      <v-card-actions>
                        <span class="text-subtitle-2">Attempts Taken: {{ editedItem.attemptCount }}</span>
                        <v-spacer></v-spacer>
                        <v-btn plain @click="close()">Cancel</v-btn>
                        <v-btn
                          color="cyan"
                          dark
                          @click="approveUser()"
                        >
                          Approve
                        </v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-form>
                </v-card>
              </v-tab-item>

              <!-- <v-tab-item :key="2" :value="'tab-2'">
                <v-card flat>
                  <v-form clearable>
                    <v-container>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                        >
                          <v-card flat>
                            <v-card-text>
                              <v-row>
                                <v-col cols="12">
                                  <span class="text-subtitle-1 black--text">Score:</span>
                                  <v-badge
                                    class="ml-2"
                                    :color="editedItem.status == 'FAIL' ? 'error' : 'success'"
                                    :content="`${editedItem.percentage}%`"
                                  ></v-badge>
                                </v-col>
                              </v-row>

                              <v-row>
                                <v-col cols="12">
                                  <v-expansion-panels>
                                    <v-expansion-panel>
                                      <v-expansion-panel-header>
                                        Responses
                                      </v-expansion-panel-header>
                                      <v-expansion-panel-content>
                                        <div
                                          v-for="(item, index) in editedItem.responsesSplit"
                                          :key="index"
                                        >
                                          <span>
                                            {{ index + 1 }}) {{ item.substring(0, 1).toUpperCase() }}
                                          </span>

                                          <span v-if="item.includes('-incorrect')">
                                            <v-icon
                                              color="error"
                                              right
                                            >
                                              mdi-close
                                            </v-icon>
                                            Correct Answer: {{ item.substring(item.length - 1).toUpperCase() }}
                                          </span>
                                        </div>
                                      </v-expansion-panel-content>
                                    </v-expansion-panel>
                                  </v-expansion-panels>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-container>

                    <v-container>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="close">Cancel</v-btn>
                        <v-btn
                          color="cyan"
                          dark
                          @click="approveUser()"
                        >
                          Approve
                        </v-btn>
                      </v-card-actions>
                    </v-container>
                  </v-form>
                </v-card>
              </v-tab-item> -->
            </v-tabs>
          </v-card>
        </v-bottom-sheet>

        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="closeDelete">Cancel</v-btn>
              <v-btn color="error" dark @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogPreviewCert"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-app-bar
              fixed
              dark
              color="primary"
              rounded=0
            >
              <v-toolbar-title>Cert Preview</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu
                offset-y
              >
                <template v-slot:activator="{ attrs, on }">
                  <v-btn
                    icon
                    dark
                    :loading="pdfProgress < 100"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item
                    @click="generateReport()"
                    v-if="!approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon
                        left
                        color="success"
                      >
                        mdi-check
                      </v-icon>
                      Approve
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="dialogSendUserCert = true"
                    v-if="approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon left>
                        mdi-email-send-outline
                      </v-icon>
                      Resend
                    </v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="downloadCert(editedItem.userExamID)"
                    v-if="approvalDone"
                  >
                    <v-list-item-title>
                      <v-icon left>
                        mdi-download-outline
                      </v-icon>
                      Download
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
                icon
                dark
                @click="close()"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-app-bar>

            <v-main class="px-0">
              <div>
                <div id="preview">
                  <div>
                    <img src="/static/img/usercert/usercert.png" width="100%" />
                  </div>

                  <div>
                    <span id="previewuser">{{ editedItem.fullName }}</span>
                    <span id="previewissuedate">{{ editedItem.issueDate }}</span>
                    <span id="previewexpirationdate">{{ editedItem.expirationDate }}</span>
                    <span id="previewreviewer">Larry Kaplan</span>
                  </div>
                </div>
              </div>

              <div>
                <vue-html2pdf
                  :show-layout="false"
                  :float-layout="true"
                  :enable-download="false"
                  :preview-modal="true"
                  :paginate-elements-by-height="816"
                  :filename="editedItem.userExamID"
                  :pdf-quality="2"
                  :manual-pagination="true"
                  pdf-format="letter"
                  pdf-orientation="landscape"
                  pdf-content-width="1052px"
                  @progress="onProgress($event)"
                  @hasDownloaded="hasDownloaded($event)"
                  ref="userCertificate"
                >
                  <section slot="pdf-content">
                    <div>
                      <div id="cert">
                        <div>
                          <img id="certimg" src="/static/img/usercert/usercert.png" width="100%" />
                        </div>

                        <div>
                          <span id="certuser">{{ editedItem.fullName }}</span>
                          <span id="certissuedate">{{ editedItem.issueDate }}</span>
                          <span id="certexpirationdate">{{ editedItem.expirationDate }}</span>
                          <span id="certreviewer">Larry Kaplan</span>
                        </div>
                      </div>
                    </div>
                  </section>
                </vue-html2pdf>
              </div>
            </v-main>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="dialogSendUserCert"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              Send User Certificate To
            </v-card-title>
            <v-card-text>
              {{ editedItem.fullName }}
              &lt;{{ editedItem.email }}&gt;
            </v-card-text>
            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="dialogSendUserCert = false"
              >
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="sendCertificate()"
              >
                Send
                <v-icon class="ml-2">mdi-send</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-divider></v-divider>
    </template>

    <template v-slot:item.username="props">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <span
            class="subtitle-1"
            style="border-bottom: 1px dashed #111; cursor: pointer;"
            @click="editItem(props.item)"
            v-bind="attrs"
            v-on="on"
          >
            {{ props.item.username }}
          </span>
        </template>
        <span>View User Approval</span>
      </v-tooltip>
    </template>

    <template v-slot:item.status="props">
      <v-badge
        :color="props.item.status == 'FAIL'? 'error': 'success'"
        inline
        :content="props.item.status"
      ></v-badge>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-menu offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                color="black"
                icon
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <span>Actions</span>
          </v-tooltip>
        </template>
        <v-list>
          <!-- <v-list-item @click="$router.push('clients/locations?customerid=' + item.customerID)">
            <v-list-item-action class="mr-4">
              <v-icon color="">mdi-domain</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Company</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
          <v-list-item @click="editItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon>mdi-magnify</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>View</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <!-- <v-list-item @click="deleteItem(item)">
            <v-list-item-action class="mr-4">
              <v-icon color="red">mdi-trash-can-outline</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item-content>
          </v-list-item> -->
        </v-list>
      </v-menu>
    </template>

    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        Reset
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
  import UserExamService from "../../../services/userExam.service"
  import AuthService from "../../../services/auth.service"
  import CustomerService from "../../../services/customer.service"
  import PdfService from "../../../services/pdf.service"
  import VueHtml2pdf from 'vue-html2pdf'
  import FileSaver from 'file-saver'
  import * as jsPDF from 'jspdf'

  export default {
    components: {
      VueHtml2pdf
    },

    data: () => ({
      search: '',
      selected: [],
      loading: false,
      sheet: false,
      tab: null,
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: "Username", align: "start", value: "username" },
        { text: "Name", value: "fullName" },
        { text: "Email", value: "email" },
        { text: "Company", value: "companyName" },
        { text: "Status", value: "status" },
        { text: "Actions", value: "actions", align: "center", sortable: false }
      ],
      userApprovals: [],
      users: [],
      role: [],
      roles: [],
      customers: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      dialogPreviewCert: false,
      dialogSendUserCert: false,
      approvalDone: false,
      pdfProgress: {
        type: Number,
        default: 0
      },
    }),

    computed: {
      currentUser() {
        return this.$store.state.auth.user;
      },

      htmlToPdfOptions() {
        return {
          margin: 0,
          image: {
            type: "png",
            quality: 0.98,
          },
          enableLinks: true,
          html2canvas: {
            scale: this.controlValue.pdfQuality,
            useCORS: true,
          },
          jsPDF: {
            unit: "in",
            format: this.controlValue.pdfFormat,
            orientation: this.controlValue.pdfOrientation,
          },
        }
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },

      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize() {
        this.checkAuth()
        this.retrieveUserApprovals()
        this.retrieveDealers()
      },

      checkAuth() {
        if (!this.$route.meta.authorize.includes(this.currentUser.roles.toString())) {
          this.$router.push('/dashboard')
        }
      },

      checkRole(role) {
        if (Array.isArray(role)) {
          var i
          for (i = 0; i < role.length; i++) {
            if (this.currentUser.roles.includes(role[i])) {
              return true
            }
            if (role[i] == 'lf') {
              if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
                return true
              }
            }
            if (role[i] == 'dealer') {
              if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
                return true
              }
            }
          }
          return false
        }

        if (role == 'lf') {
          if (this.currentUser.roles.includes('ROLE_LFADMIN') || this.currentUser.roles.includes('ROLE_LFTECH') || this.currentUser.roles.includes('ROLE_LFBILLING')) {
            return true
          }
        }

        if (role == 'dealer') {
          if (this.currentUser.roles.includes('ROLE_DEALERADMIN') || this.currentUser.roles.includes('ROLE_DEALERTECH')) {
            return true
          }
        }

        if (this.currentUser.roles.includes(role)) {
          return true
        } else {
          return false
        }
      },

      async retrieveUserApprovals() {
        this.loading = true
        await UserExamService.getAllPendingApproval()
          .then(response => {
            this.userApprovals = response.data

            for (const item of this.userApprovals) {
              item.responsesSplit = item.responses.split(';')
              item.answersSplit = item.answers.split(';')
              item.responsesSplit.pop()
              item.answersSplit.pop()
              item.incorrect = 0

              for (let i = 0; i < item.responsesSplit.length; i++) {
                if (item.responsesSplit[i] != item.answersSplit[i]) {
                  item.responsesSplit[i] = `${item.responsesSplit[i]}-incorrect-${item.answersSplit[i]}`
                  item.incorrect++
                }
              }
              item.status = (item.incorrect > 0 ? 'FAIL' : 'PASS')
              item.percentage = 100 / (item.answersSplit.length / (item.answersSplit.length - item.incorrect))
            }

            return new Promise(resolve => {
              resolve('Done')
            })
          })
          .catch(e => {
            console.log(e)
          })

        if (this.$route.query.username) {
          this.search = this.$route.query.username
        }

        this.loading = false
      },

      retrieveDealers() {
        CustomerService.getDealers()
        .then(response => {
          this.customers = response.data || []
        })
        .catch(e => {
          console.log(e)
        })
      },

      approveUser() {
        if (this.editedItem.status != 'PASS') {
          this.snackbar('Error! The user did not pass the exam', 'error')
          return
        }

        if (!this.editedItem.customerID) {
          this.snackbar('Error! Missing corresponding company', 'error')
          return
        }

        if (this.editedItem.role == 'Administrator') {
          this.rolePush('dealeradmin')
        } else if (this.editedItem.role == 'Technician') {
          this.rolePush('dealertech')
        }

        var date = new Date()
        this.editedItem.approvedAt = date.toISOString()
        this.editedItem.issueDate = date.toISOString().split('T')[0]
        this.editedItem.expirationDate = new Date(date.setMonth(date.getMonth() + 12)).toISOString().split('T')[0]
        this.dialogPreviewCert = true
      },

      migrateUser() {
        AuthService.migrate(this.editedItem)
          .then(response => {
            // this.snackbar('Success! The user was approved successfully','success')

            UserExamService.update(this.editedItem.userExamID, { approvedAt: this.editedItem.approvedAt })
              .then(response => {
                this.dialogSendUserCert = true
                this.approvalDone = true
                this.userApprovals.splice(this.editedIndex, 1)
              })
              .catch(e => {
                console.log(e)
              })
          })
          .catch(e => {
            console.log(e)
            this.snackbar('Error! There was an error approving the user', 'error')
          })
      },

      generateReport() {
        this.$refs.userCertificate.generatePdf()
      },

      async hasDownloaded(blob) {
        const pdf = new File([blob], `${this.editedItem.userExamID}.pdf`, {
          type: "application/pdf",
        })

        const fd = new FormData()
        fd.append('pdf', pdf, pdf.name)

        PdfService.createUserCert(fd)
          .then(res => {
            this.snackbar('Success! The user certificate was stored successfully', 'success')
          })
          .catch(e => {
            console.log(e)
            this.snackbar('Error! There was an error storing the user certificate.', 'error', '6000')
          })

        this.migrateUser()
      },

      sendCertificate() {
        PdfService.sendUserCert(this.editedItem.userExamID)
          .then(response => {
            this.snackbar('Success! User certificate sent successfully', 'success', '6000')
            this.dialogSendUserCert = false
          })
          .catch(e => {
            console.log(e)
            this.snackbar('Error! Error sending user certificate', 'error', '0')
          })
      },

      onProgress(pdfProgress) {
        this.pdfProgress = pdfProgress
      },

      downloadCert(userExamID) {
        window.open(`${process.env.VUE_APP_BASE_URL}/pdfs/user/${userExamID}`)
      },

      companyCopy() {
        //Not working
        this.editedItem.customerID = this.editedItem.companyName
      },

      roleSwap() {
        this.editedItem.role = ( this.editedItem.role == 'Administrator' ? 'Technician' : 'Administrator' )
      },

      rolePush(role) {
        this.role = []
        if (!this.editedItem.roles) {
          this.editedItem.roles = []
          this.editedItem.roles[0] = {
            "roleName": null
          }
        }

        this.role.push(role)
        this.editedItem.roles[0].roleName = role

        if (role.substring(0, 6) == 'client') {
          this.retrieveClients()
        } else if (role.substring(0, 6) == 'dealer') {
          if (this.checkRole('lf')) {
            this.retrieveDealers()
          } else {
            this.editedItem.customerID = this.currentUser.customerID
          }
        }
      },














      routerPush(customerID) {
        if (this.isDealer(customerID)) {
          this.$router.push('/companies/clients?dealerid=' + customerID);
        } else {
          this.$router.push('/companies/locations?customerid=' + customerID);
        }
      },

      clearSheet() {
        this.close()
        this.editedItem.fullName = ""
        this.editedItem.username = ""
        this.editedItem.password = ""
        this.editedItem.companyID = null
        this.editedItem.roles = []
        this.editedItem.role = ""
        this.editedItem.email = ""
        this.editedItem.phone = ""
        this.editedItem.metric = 0
        this.editedItem.timezone = ""
        this.editedItem.resetPassword = ""
        this.editedIndex = -1
        this.showPasswordField = true
        this.tab = 1
      },

      editItem(item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.sheet = true
      },

      deleteItem(item) {
        this.editedIndex = this.users.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm() {
        this.users.splice(this.editedIndex, 1)
        this.deleteUser();
        this.closeDelete()
      },

      close() {
        this.sheet = false
        this.dialogPreviewCert = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete() {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      snackbar(message, color, timeout) {
        window._LOL2P.$emit('SHOW_SNACKBAR', {
          text: message,
          color: color,
          timeout: timeout
        })
      },
    },
  }
</script>

<style>
@import '/static/css/usercertgenerate.css';
@import '/static/css/usercertpreview.css';
</style>